import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-customercellbuttonrenderer',
    templateUrl: './customercellbuttonrenderer.component.html',
    styleUrls: ['./customercellbuttonrenderer.component.scss'],
    standalone: false
})
export class CustomercellbuttonrendererComponent {
    params: any = {};
    paramStore: any = {};

    // Download Report button
    hideButton: boolean = false;
    disableButton: boolean = false;
    hideButtonText: string = '';
    buttonText: string = '';
    buttonClass: string = 'btn btn-primary btn-sm';
    buttonIcon: string = '';
    buttonName: string = '';

    // Probation button
    hideProbationButton: boolean = true;
    probationButtonText: string = '';
    probationButtonClass: string = 'btn btn-default btn-sm';
    probationButtonIcon: string = '';
    probationButtonName: string = '';

    // Reorder button
    hideReorderButton: boolean = true;
    reorderButtonText: string = 'Reorder';
    reorderButtonClass: string = 'btn btn-warning btn-sm mt-n1 text-nowrap';
    reorderButtonName: string = '';
    reorderButtonPopoverText: string = '';
    reorderButtonIcon: string = '';
    reorderButtonDisabled: boolean = false;

    buttonClick(params: any) {
        if (this.paramStore!.hasOwnProperty('callback')) {
            this.paramStore.callback(this.paramStore!.data!.authCode, this.paramStore!.data!.driversConsent);
        }
    }

    probationButtonClick(params: any) {
        if (this.paramStore!.hasOwnProperty('probationButtonCallback')) {
            this.paramStore.probationButtonCallback(this.paramStore!.data!.authCode,
                this.paramStore!.data!.probationStatusId,
                this.paramStore!.data!.documentId,
                this.paramStore!.data!.firstName,
                this.paramStore!.data!.lastName,
                this.paramStore!.data!.requestDate);

        }
    }

    monitorButtonClick(params: any) {
        if (this.paramStore!.hasOwnProperty('monitorButtonCallback')) {
            this.paramStore.monitorButtonCallback(this.paramStore!.data!.authCode);
        }
    }

    reorderButtonClick(params: any) {
        if (this.paramStore!.hasOwnProperty('reorderButtonCallback')) {
            this.paramStore.reorderButtonCallback(this.paramStore!.data!.authCode);
        }
    }

    // gets called whenever the cell refreshes
    refresh(params: ICellRendererParams): boolean {
        this.paramStore = params;

        // Check if properties have been set in params and, if so, assign to control props.

        // Probation Button
        if ('hideProbationButton' in params &&
            typeof params.hideProbationButton === 'function') {
            this.hideProbationButton = params.hideProbationButton(params);
        }
        if ('probationButtonName' in params &&
            typeof params.probationButtonName === 'function') {
            this.probationButtonName = params.probationButtonName(params);
        }
        if ('probationButtonClass' in params) {
            this.probationButtonClass = params['probationButtonClass'] as string;
        }
        if ('probationButtonIcon' in params) {
            this.probationButtonIcon = params['probationButtonIcon'] as string;
        }
        if ('probationButtonText' in params &&
            typeof params.probationButtonText === 'function') {
            this.probationButtonText = params.probationButtonText(params);
        }

        // Download Report Button
        if ('buttonText' in params &&
            typeof params.buttonText === 'function') {
            this.buttonText = params.buttonText(params!.data!.probationStatusId, params!.data!.requestDate);
        }
        if ('buttonClass' in params) {
            this.buttonClass = params['buttonClass'] as string;
        }
        if ('buttonIcon' in params) {
            this.buttonIcon = params['buttonIcon'] as string;
        }
        if ('hideButton' in params &&
            typeof params.hideButton === 'function') {
            this.hideButton = params.hideButton(params!.data!.probationStatusId, params!.data!.requestDate);
        }
        if ('disableButton' in params &&
            typeof params.disableButton === 'function') {
            this.disableButton = params.disableButton(params!.data!.probationStatusId, params!.data!.requestDate);
        }
        if ('hideButtonText' in params &&
            typeof this.params!.hideButtonText === 'function') {
            this.hideButtonText = this.params.hideButtonText(params!.data!.authCode);
        }
        if ('buttonName' in params &&
            typeof this.params!.buttonName === 'function') {
            this.buttonName = this.params.buttonName(params!.data!.authCode);
        }

        // Reorder button
        if ('reorderButtonText' in params && 
            typeof params.reorderButtonText === 'function') {
            this.reorderButtonText = params.reorderButtonText(params);
        }
        if ('reorderButtonClass' in params) {
            this.reorderButtonClass = params['reorderButtonClass'] as string;
        }
        if ('reorderButtonName' in params &&
            typeof params.reorderButtonName === 'function') {
            this.reorderButtonName = params.reorderButtonName(params);
        }
        if ('hideReorderButton' in params &&
            typeof params.hideReorderButton === 'function') {
            this.hideReorderButton = params.hideReorderButton(params);
        }
        if ('reorderButtonPopoverText' in params && 
            typeof params.reorderButtonPopoverText === 'function') {
            this.reorderButtonPopoverText = params.reorderButtonPopoverText(params);
        }
        if ('reorderButtonIcon' in params) {
            this.reorderButtonIcon = params['reorderButtonIcon'] as string;
        }
        if ('reorderButtonDisabled' in params &&
            typeof params.reorderButtonDisabled === 'function') {
            this.reorderButtonDisabled = params.reorderButtonDisabled(params);
        }

        // set value into cell again
        this.paramStore = params;
        return true;
    }

    getValueToDisplay(params: ICellRendererParams) {
        return params.valueFormatted ? params.valueFormatted : params.value;
    }

    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        // this.displayValue = params.value;
        this.paramStore = params;

        // Check if properties have been set in params and, if so, assign to control props.

        // Probation button
        if ('hideProbationButton' in params &&
            typeof params.hideProbationButton === 'function') {
            this.hideProbationButton = params.hideProbationButton(params);
        }
        if ('probationButtonName' in params &&
            typeof params.probationButtonName === 'function') {
            this.probationButtonName = params.probationButtonName(params);
        }
        if ('probationButtonClass' in params) {
            this.probationButtonClass = params['probationButtonClass'] as string;
        }
        if ('probationButtonIcon' in params) {
            this.probationButtonIcon = params['probationButtonIcon'] as string;
        }
        if ('probationButtonText' in params &&
            typeof params.probationButtonText === 'function') {
            this.probationButtonText = params.probationButtonText(params);
        }

        // Download Report button
        if ('buttonText' in params &&
            typeof params.buttonText === 'function') {
            this.buttonText = params.buttonText(params!.data!.probationStatusId, params!.data!.requestDate);
        }
        if ('buttonClass' in params) {
            this.buttonClass = params['buttonClass'] as string;
        }
        if ('buttonIcon' in params) {
            this.buttonIcon = params['buttonIcon'] as string;
        }
        if ('hideButton' in params &&
            typeof params.hideButton === 'function') {
            this.hideButton = params.hideButton(params!.data!.probationStatusId, params!.data!.requestDate);
        }
        if ('disableButton' in params &&
            typeof params.disableButton === 'function') {
            this.disableButton = params.disableButton(params!.data!.probationStatusId, params!.data!.requestDate);
        }
        if ('hideButtonText' in params &&
            typeof this.params!.hideButtonText === 'function') {
            this.hideButtonText = this.params.hideButtonText(params!.data!.authCode);
        }
        if ('buttonName' in params &&
            typeof this.params!.buttonName === 'function') {
            this.buttonName = this.params.buttonName(params!.data!.authCode);
        }

        // Reorder button
        if ('reorderButtonText' in params && 
            typeof params.reorderButtonText === 'function') {
            this.reorderButtonText = params.reorderButtonText(params);
        }
        if ('reorderButtonClass' in params) {
            this.reorderButtonClass = params['reorderButtonClass'] as string;
        }
        if ('reorderButtonName' in params &&
            typeof params.reorderButtonName === 'function') {
            this.reorderButtonName = params.reorderButtonName(params);
        }
        if ('hideReorderButton' in params &&
            typeof params.hideReorderButton === 'function') {
            this.hideReorderButton = params.hideReorderButton(params);
        }
        if ('reorderButtonPopoverText' in params && 
            typeof params.reorderButtonPopoverText === 'function') {
            this.reorderButtonPopoverText = params.reorderButtonPopoverText(params);
        }
        if ('reorderButtonIcon' in params) {
            this.reorderButtonIcon = params['reorderButtonIcon'] as string;
        }
        if ('reorderButtonDisabled' in params &&
            typeof params.reorderButtonDisabled === 'function') {
            this.reorderButtonDisabled = params.reorderButtonDisabled(params);
        }
    }
}
